import { getDueScheduledServices, autoAssignScheduledService } from '../components/DELIVERY/services/deliveryServices';

const CHECK_INTERVAL_MS = 15 * 60 * 1000;
let intervalId = null;

export function startScheduledServiceWorker() {
  if (intervalId) return;
  intervalId = setInterval(checkDueServices, CHECK_INTERVAL_MS);
  checkDueServices();
}

export function stopScheduledServiceWorker() {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
}

async function checkDueServices() {
  try {
    const due = await getDueScheduledServices();
    for (const service of due) {
      await autoAssignScheduledService(service.id);
      console.log(`Auto-asignado servicio programado ${service.id}`);
    }
  } catch (err) {
    console.error('Error en ScheduledServiceWorker:', err);
  }
}
